var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.value
    ? _c(
        "div",
        {
          staticClass: "cell is-col-span-1 is-flex",
          staticStyle: { position: "relative" },
          attrs: { inert: _vm.isSaving },
          on: { focusout: _vm.onComponentFocusOut },
        },
        [
          _vm.isSaving
            ? _c("div", { staticClass: "quote-item-saving-overlay" })
            : _vm._e(),
          _c("article", { staticClass: "box is-flex-grow-1" }, [
            _c("div", { staticClass: "columns mb-0" }, [
              _vm._m(0),
              _vm.innerVehicle.model && (_vm.isOrm || _vm.isNtar)
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "column is-flex is-justify-content-flex-end",
                      },
                      [
                        _vm.ntarLtarStatus
                          ? _c("div", [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "tag is-success animate__animated animate__pulse animate__repeat-3 tooltip",
                                  attrs: {
                                    "data-tooltip": `${_vm.ntarLtarStatus} schedule and times found`,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.ntarLtarStatus) +
                                      " Hours On - " +
                                      _vm._s(_vm.innerVehicle.model.scheduleId)
                                  ),
                                ]
                              ),
                            ])
                          : _c("div", [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "tag is-danger animate__animated animate__pulse animate__repeat-3 tooltip",
                                  attrs: {
                                    "data-tooltip": `NTAR/LTAR  times not found`,
                                  },
                                },
                                [_vm._v("NTAR/LTAR Hours OFF")]
                              ),
                            ]),
                      ]
                    ),
                  ])
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass:
                    "is-flex is-justify-content-flex-end is-align-items-center pr-3",
                },
                [
                  _c(
                    "p",
                    { staticClass: "mb-0 mr-1 label has-text-weight-normal" },
                    [_vm._v("Key No.")]
                  ),
                  _c("span", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.innerQuote.keyNo,
                          expression: "innerQuote.keyNo",
                        },
                      ],
                      staticClass: "input input-box-keyno",
                      attrs: {
                        type: "text",
                        maxlength: "4",
                        disabled: _vm.readyOnlyForSubQuote,
                        placeholder: "0000",
                      },
                      domProps: { value: _vm.innerQuote.keyNo },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.innerQuote, "keyNo", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ]
              ),
            ]),
            _c("div", { staticClass: "is-divider" }),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c(
                    "label",
                    {
                      staticClass: "label is-required-label",
                      staticStyle: { "white-space": "nowrap" },
                    },
                    [_vm._v("Registration No.")]
                  ),
                  _c("div", { staticClass: "field" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              theme: "danger",
                              enabled:
                                _vm.$v.vehicle.rego.$error &&
                                !_vm.$v.vehicle.rego.ormMaxLength,
                            },
                            expression:
                              "{ theme: 'danger', enabled: $v.vehicle.rego.$error && !$v.vehicle.rego.ormMaxLength }",
                          },
                        ],
                        staticClass: "control",
                        attrs: { content: _vm.ormMessages.rego.ormMaxLength },
                      },
                      [
                        _c("bulma-autocomplete", {
                          ref: "vehicleAutocomplete",
                          attrs: {
                            "class-prop": !_vm.$v.vehicle.rego.$error
                              ? "is-uppercase is-required-field"
                              : "is-uppercase is-invalid",
                            value: _vm.innerVehicle.rego,
                            data: _vm.vehicles,
                            field: "rego",
                            maxlength: _vm.regoMaxLength,
                            loading: _vm.isSearchingVehicle,
                            expanded: true,
                            disabled: _vm.readyOnlyForSubQuote,
                          },
                          on: {
                            input: _vm.searchVehicle,
                            select: _vm.selectVehicle,
                            onEnter: _vm.handleVehiclePickerEnter,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c("div", [
                                      _vm._v(_vm._s(props.option.rego)),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "help is-primary" },
                                      [_vm._v(_vm._s(props.option.model))]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "help is-primary" },
                                      [_vm._v(_vm._s(props.option.ownersName))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4206719517
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm.$company.info.countryCode === "AU"
                  ? _c("div", { staticClass: "field is-align-self-flex-end" }, [
                      _c("label", { staticClass: "label" }, [_vm._v("State")]),
                      _c("div", { staticClass: "control is-extended" }, [
                        _c(
                          "div",
                          {
                            staticClass: "select is-fullwidth",
                            staticStyle: { width: "100px" },
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.innerVehicle.stateRego,
                                    expression: "innerVehicle.stateRego",
                                  },
                                ],
                                attrs: { disabled: _vm.readyOnlyForSubQuote },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.innerVehicle,
                                      "stateRego",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "option",
                                  { attrs: { value: "null", disabled: "" } },
                                  [_vm._v("Select")]
                                ),
                                _vm._l(_vm.stateRegoTypes, function (a, b) {
                                  return _c(
                                    "option",
                                    { key: b, domProps: { value: b } },
                                    [_vm._v(_vm._s(a))]
                                  )
                                }),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm.$company.info.countryCode === "AU"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "field is-flex-grow-0 is-align-self-flex-end",
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "button is-primary is-rounded",
                            attrs: { disabled: _vm.readyOnlyForSubQuote },
                            on: {
                              click: function ($event) {
                                _vm.isVehicleLookupModalActive = true
                              },
                            },
                          },
                          [_vm._m(1), _c("span", [_vm._v("Rego Lookup")])]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            false
              ? _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "field has-addons" }, [
                    _c(
                      "div",
                      { staticClass: "control is-expanded" },
                      [
                        _vm.vehicles
                          ? _c(
                              "multiselect",
                              {
                                class: [
                                  !_vm.$v.vehicle.id.$error
                                    ? "is-required-field"
                                    : "is-invalid",
                                ],
                                attrs: {
                                  id: "quote-vehicle-multiselect",
                                  "deselect-label": "Can't remove this value",
                                  "track-by": "vehicleId",
                                  label: "rego",
                                  placeholder: "Search By Rego...",
                                  options: _vm.vehicles,
                                  loading: _vm.isSearchingVehicle,
                                  "internal-search": false,
                                  "options-limit": _vm.vehicleFilter.pageSize,
                                  searchable: true,
                                  "show-labels": false,
                                  "allow-empty": false,
                                },
                                on: {
                                  select: _vm.selectVehicle,
                                  remove: _vm.removeVehicle,
                                  "search-change": _vm.getVehicleDropdownFilter,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "singleLabel",
                                      fn: function ({ option }) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(option.rego) + " "
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "option",
                                      fn: function (props) {
                                        return [
                                          _c("div", [
                                            _vm._v(_vm._s(props.option.rego)),
                                          ]),
                                          _c(
                                            "div",
                                            { staticClass: "help is-primary" },
                                            [_vm._v(_vm._s(props.option.model))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2755501754
                                ),
                                model: {
                                  value: _vm.selectedVehicle,
                                  callback: function ($$v) {
                                    _vm.selectedVehicle = $$v
                                  },
                                  expression: "selectedVehicle",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "has-text-danger",
                                    attrs: { slot: "noResult" },
                                    slot: "noResult",
                                  },
                                  [_vm._v("Vehicle not found.")]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "control" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-primary tooltip",
                          attrs: { "data-tooltip": "Rego lookup service" },
                          on: {
                            click: function ($event) {
                              _vm.isVehicleLookupModalActive = true
                            },
                          },
                        },
                        [_vm._m(2)]
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label is-required-label" }, [
                    _vm._v("Make / Model"),
                  ]),
                  _c("div", { staticClass: "field has-addons" }, [
                    _c(
                      "div",
                      { staticClass: "control is-expanded" },
                      [
                        _c("bulma-autocomplete", {
                          attrs: {
                            "class-prop": !_vm.$v.vehicle.model.$error
                              ? "is-required-field"
                              : "is-invalid",
                            value: _vm.makeModelText,
                            data: _vm.filteredMakeModels,
                            field: "name",
                            disabled: _vm.readyOnlyForSubQuote,
                            loading: _vm.isSearchingMakeModel,
                            expanded: true,
                          },
                          on: {
                            input: _vm.searchMakeModel,
                            select: _vm.selectMakeModel,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c("div", [
                                      _vm._v(_vm._s(props.option.name)),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "help is-primary" },
                                      [
                                        _vm._v(
                                          _vm._s(props.option.cylinders) +
                                            " Cylinders"
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "help is-primary" },
                                      [_vm._v(_vm._s(props.option.production))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2875817655
                          ),
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "control" }, [
                      _vm.modelId === ""
                        ? _c(
                            "button",
                            {
                              staticClass: "button has-text-success tooltip",
                              attrs: {
                                "data-tooltip": "Add unscheduled model",
                                disabled: _vm.readyOnlyForSubQuote,
                              },
                              on: { click: _vm.addModel },
                            },
                            [_vm._m(3)]
                          )
                        : _vm._e(),
                      _vm.modelId !== "" && _vm.innerVehicle.model.isUnscheduled
                        ? _c(
                            "button",
                            {
                              staticClass: "button has-text-primary tooltip",
                              attrs: {
                                "data-tooltip": "Edit unscheduled model",
                                disabled: _vm.readyOnlyForSubQuote,
                              },
                              on: { click: _vm.checkMultipleModelCustomExists },
                            },
                            [_vm._m(4)]
                          )
                        : _vm._e(),
                      _vm.modelId !== "" &&
                      !_vm.innerVehicle.model.isUnscheduled
                        ? _c(
                            "button",
                            {
                              staticClass: "button has-text-success tooltip",
                              attrs: {
                                "data-tooltip": "Create unscheduled model",
                                disabled: _vm.readyOnlyForSubQuote,
                              },
                              on: { click: _vm.copyModel },
                            },
                            [_vm._m(5)]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "field is-flex-grow-0 is-align-self-flex-end",
                  },
                  [
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "button is-primary is-light is-rounded",
                          class: `is-light-btn-${_vm.$theme.name}`,
                          attrs: { disabled: _vm.readyOnlyForSubQuote },
                          on: {
                            click: function ($event) {
                              _vm.isCarModelSearchModalActive = true
                            },
                          },
                        },
                        [_vm._m(6), _c("span", [_vm._v("Schedules")])]
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
            _c("div", { staticClass: "columns field" }, [
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label is-required-label" }, [
                    _vm._v("Body Style"),
                  ]),
                  _c("div", { staticClass: "control is-expanded" }, [
                    _c(
                      "div",
                      {
                        staticClass: "select is-fullwidth",
                        class: !_vm.$v.vehicle.bodyId.$error
                          ? "is-required-field"
                          : "is-invalid",
                      },
                      [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.innerVehicle.bodyId,
                                expression: "innerVehicle.bodyId",
                              },
                            ],
                            attrs: { disabled: _vm.readyOnlyForSubQuote },
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.innerVehicle,
                                    "bodyId",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                _vm.onChangeBodyStyle,
                              ],
                            },
                          },
                          [
                            _c(
                              "option",
                              { attrs: { value: "null", disabled: "" } },
                              [_vm._v("Select")]
                            ),
                            _vm._l(_vm.bodyStyles, function (s, index) {
                              return _c(
                                "option",
                                { key: index, domProps: { value: s.id } },
                                [_vm._v(" " + _vm._s(s.name) + " ")]
                              )
                            }),
                          ],
                          2
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Body Style 2"),
                  ]),
                  _c("div", { staticClass: "control is-extended" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              theme: "danger",
                              enabled: _vm.$v.vehicle.bodyId2.$error,
                            },
                            expression:
                              "{ theme: 'danger', enabled: $v.vehicle.bodyId2.$error}",
                          },
                        ],
                        staticClass: "select is-fullwidth",
                        class: { "is-invalid": _vm.$v.vehicle.bodyId2.$error },
                        attrs: { content: "Required by ORM." },
                      },
                      [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.innerVehicle.bodyId2,
                                expression: "innerVehicle.bodyId2",
                              },
                            ],
                            ref: "bodyId2",
                            attrs: { disabled: _vm.readyOnlyForSubQuote },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.innerVehicle,
                                  "bodyId2",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "option",
                              { attrs: { value: "null", disabled: "" } },
                              [_vm._v("Select")]
                            ),
                            _vm._l(_vm.bodyStyles2, function (s, index) {
                              return _c(
                                "option",
                                { key: index, domProps: { value: s.id } },
                                [_vm._v(" " + _vm._s(s.name) + " ")]
                              )
                            }),
                          ],
                          2
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "columns field" }, [
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label is-required-label" }, [
                    _vm._v("Paint Group"),
                  ]),
                  _c(
                    "div",
                    {
                      class: {
                        "is-flex":
                          _vm.innerVehicle.paintGroup ===
                          _vm.paintGroupTypes.M3,
                      },
                    },
                    [
                      _c("div", { staticClass: "control is-expanded" }, [
                        _c(
                          "div",
                          {
                            staticClass: "select is-fullwidth",
                            class: !_vm.$v.vehicle.paintGroup.$error
                              ? "is-required-field"
                              : "is-invalid",
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.innerVehicle.paintGroup,
                                    expression: "innerVehicle.paintGroup",
                                  },
                                ],
                                ref: "paintGroup",
                                staticClass: "control-min-width",
                                attrs: { disabled: _vm.readyOnlyForSubQuote },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.innerVehicle,
                                        "paintGroup",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                    function ($event) {
                                      return _vm.selectPaintGroup($event)
                                    },
                                  ],
                                },
                              },
                              [
                                _c(
                                  "option",
                                  { attrs: { value: "null", disabled: "" } },
                                  [_vm._v("Select")]
                                ),
                                _vm._l(_vm.paintGroups, function (p, index) {
                                  return _c(
                                    "option",
                                    { key: index, domProps: { value: p.key } },
                                    [_vm._v(" " + _vm._s(p.value) + " ")]
                                  )
                                }),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]),
                      _vm.innerVehicle.paintGroup === _vm.paintGroupTypes.M3
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "control is-flex is-align-items-center pl-4",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "pretty p-icon p-curve p-smooth",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.innerVehicle.paintGroupPlus,
                                        expression:
                                          "innerVehicle.paintGroupPlus",
                                      },
                                    ],
                                    attrs: {
                                      disabled: _vm.readyOnlyForSubQuote,
                                      type: "checkbox",
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.innerVehicle.paintGroupPlus
                                      )
                                        ? _vm._i(
                                            _vm.innerVehicle.paintGroupPlus,
                                            null
                                          ) > -1
                                        : _vm.innerVehicle.paintGroupPlus,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.innerVehicle.paintGroupPlus,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.innerVehicle,
                                                "paintGroupPlus",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.innerVehicle,
                                                "paintGroupPlus",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.innerVehicle,
                                            "paintGroupPlus",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _vm._m(7),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]),
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Build Date")]),
                  _c("div", { staticClass: "field has-addons" }, [
                    _c("div", { staticClass: "control" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                theme: "danger",
                                enabled: _vm.$v.vehicle.buildMonth.$error,
                              },
                              expression:
                                "{ theme: 'danger', enabled: $v.vehicle.buildMonth.$error }",
                            },
                          ],
                          staticClass: "select",
                          class: {
                            "is-invalid": _vm.$v.vehicle.buildMonth.$error,
                          },
                          attrs: { content: "Required by ORM." },
                        },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.innerVehicle.buildMonth,
                                  expression: "innerVehicle.buildMonth",
                                },
                              ],
                              attrs: { disabled: _vm.readyOnlyForSubQuote },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.innerVehicle,
                                    "buildMonth",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "option",
                                { attrs: { value: "null", disabled: "" } },
                                [_vm._v("MM")]
                              ),
                              _vm._l(_vm.months, function (month, key) {
                                return _c(
                                  "option",
                                  { key: key, domProps: { value: key } },
                                  [_vm._v(_vm._s(month))]
                                )
                              }),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]),
                    _c(
                      "p",
                      { staticClass: "control" },
                      [
                        _c("the-mask", {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                theme: "danger",
                                enabled: _vm.$v.vehicle.buildYear.$error,
                              },
                              expression:
                                "{ theme: 'danger', enabled: $v.vehicle.buildYear.$error }",
                            },
                          ],
                          staticClass: "input",
                          class: {
                            "is-invalid": _vm.$v.vehicle.buildYear.$error,
                          },
                          attrs: {
                            placeholder: "Year",
                            mask: ["####"],
                            disabled: _vm.readyOnlyForSubQuote,
                            content: "Required by ORM.",
                          },
                          nativeOn: {
                            blur: function ($event) {
                              return _vm.checkYear.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.innerVehicle.buildYear,
                            callback: function ($$v) {
                              _vm.$set(_vm.innerVehicle, "buildYear", $$v)
                            },
                            expression: "innerVehicle.buildYear",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "columns field" }, [
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Transmission"),
                  ]),
                  _c("div", { staticClass: "control is-extended" }, [
                    _c(
                      "div",
                      {
                        staticClass: "select is-fullwidth",
                        class: {
                          "is-invalid": _vm.$v.vehicle.transmissionType.$error,
                        },
                      },
                      [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.innerVehicle.transmissionType,
                                expression: "innerVehicle.transmissionType",
                              },
                            ],
                            attrs: { disabled: _vm.readyOnlyForSubQuote },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.innerVehicle,
                                  "transmissionType",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "option",
                              { attrs: { value: "null", disabled: "" } },
                              [_vm._v("Select")]
                            ),
                            _vm._l(_vm.transmissionTypes, function (a, b) {
                              return _c(
                                "option",
                                { key: b, domProps: { value: b } },
                                [_vm._v(_vm._s(a))]
                              )
                            }),
                          ],
                          2
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Colour")]),
                  _c(
                    "p",
                    { staticClass: "control" },
                    [
                      _c("bulma-autocomplete", {
                        staticClass: "is-capitalized control-min-width",
                        attrs: {
                          data: _vm.colours,
                          expanded: true,
                          disabled: _vm.readyOnlyForSubQuote,
                          "class-prop": _vm.$v.vehicle.colour.$error
                            ? "is-invalid"
                            : "",
                          maxlength: "20",
                        },
                        model: {
                          value: _vm.innerVehicle.colour,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerVehicle, "colour", $$v)
                          },
                          expression: "innerVehicle.colour",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("VIN")]),
                  _c(
                    "p",
                    { staticClass: "control" },
                    [
                      _c("the-mask", {
                        staticClass: "input is-uppercase",
                        attrs: {
                          name: "vin",
                          mask: _vm.vinMask,
                          tokens: _vm.vinTokens,
                          disabled: _vm.readyOnlyForSubQuote,
                        },
                        model: {
                          value: _vm.innerVehicle.vin,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerVehicle, "vin", $$v)
                          },
                          expression: "innerVehicle.vin",
                        },
                      }),
                    ],
                    1
                  ),
                  !_vm.$v.vehicle.vin.customMinLength
                    ? _c("span", { staticClass: "help is-danger" }, [
                        _vm._v("Vin should have at least 7 characters"),
                      ])
                    : _vm._e(),
                  !_vm.$v.vehicle.vin.maxLength
                    ? _c("span", { staticClass: "help is-danger" }, [
                        _vm._v("Vin max 17 characters"),
                      ])
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Engine No.")]),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.innerVehicle.engineNo,
                          expression: "innerVehicle.engineNo",
                        },
                      ],
                      staticClass: "input",
                      attrs: {
                        disabled: _vm.readyOnlyForSubQuote,
                        maxlength: "30",
                        type: "text",
                      },
                      domProps: { value: _vm.innerVehicle.engineNo },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.innerVehicle,
                            "engineNo",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Odometer")]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("the-mask", {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              theme: "danger",
                              enabled: _vm.$v.entity.odometer.$error,
                            },
                            expression:
                              "{ theme: 'danger', enabled: $v.entity.odometer.$error }",
                          },
                        ],
                        staticClass: "input",
                        class: { "is-invalid": _vm.$v.entity.odometer.$error },
                        attrs: {
                          placeholder: "e.g. 6",
                          disabled: _vm.readyOnlyForSubQuote,
                          mask: ["##########"],
                          content:
                            "Required by ORM. Must be greater than 0 and less than 10,000,000.",
                        },
                        model: {
                          value: _vm.innerQuote.odometer,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerQuote, "odometer", $$v)
                          },
                          expression: "innerQuote.odometer",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Cylinders")]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("the-mask", {
                        staticClass: "input",
                        attrs: {
                          placeholder: "e.g. 6",
                          disabled: _vm.readyOnlyForSubQuote,
                          mask: ["##"],
                        },
                        model: {
                          value: _vm.innerVehicle.cylinders,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerVehicle, "cylinders", $$v)
                          },
                          expression: "innerVehicle.cylinders",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Engine Size"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("the-mask", {
                        staticClass: "input",
                        attrs: {
                          placeholder: "e.g. 1300",
                          mask: _vm.engineSizeMask,
                          disabled: _vm.readyOnlyForSubQuote,
                          tokens: _vm.engineSizeTokens,
                        },
                        model: {
                          value: _vm.innerVehicle.engineSize,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerVehicle, "engineSize", $$v)
                          },
                          expression: "innerVehicle.engineSize",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Trim Code")]),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.innerVehicle.trimCode,
                          expression: "innerVehicle.trimCode",
                        },
                      ],
                      staticClass: "input",
                      attrs: {
                        disabled: _vm.readyOnlyForSubQuote,
                        maxlength: "10",
                        type: "text",
                      },
                      domProps: { value: _vm.innerVehicle.trimCode },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.innerVehicle,
                            "trimCode",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Paint Code")]),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.innerVehicle.paintCode,
                          expression: "innerVehicle.paintCode",
                        },
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            theme: "danger",
                            enabled: _vm.$v.vehicle.paintCode.$error,
                          },
                          expression:
                            "{ theme: 'danger', enabled: $v.vehicle.paintCode.$error }",
                        },
                      ],
                      staticClass: "input",
                      class: { "is-invalid": _vm.$v.vehicle.paintCode.$error },
                      attrs: {
                        content: _vm.ormMessages.paintCode.ormMaxLength,
                        disabled: _vm.readyOnlyForSubQuote,
                        maxlength: "100",
                        type: "text",
                      },
                      domProps: { value: _vm.innerVehicle.paintCode },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.innerVehicle,
                            "paintCode",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm.isVehicleLookupModalActive
            ? _c(
                "vehicle-lookup-modal",
                {
                  attrs: {
                    active: _vm.isVehicleLookupModalActive,
                    "state-rego": _vm.innerVehicle.stateRego,
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.isVehicleLookupModalActive = $event
                    },
                    close: function ($event) {
                      _vm.isVehicleLookupModalActive = false
                    },
                    select: _vm.selectVehicleMakeModel,
                  },
                  model: {
                    value: _vm.innerVehicle.rego,
                    callback: function ($$v) {
                      _vm.$set(_vm.innerVehicle, "rego", $$v)
                    },
                    expression: "innerVehicle.rego",
                  },
                },
                [
                  _c(
                    "p",
                    { attrs: { slot: "text-title" }, slot: "text-title" },
                    [_vm._v("Make/Model Lookup")]
                  ),
                ]
              )
            : _vm._e(),
          _c("car-model-search-modal", {
            attrs: {
              visible: _vm.isCarModelSearchModalActive,
              make: _vm.innerVehicle.model ? _vm.innerVehicle.model.make : "",
              model: _vm.innerVehicle.model ? _vm.innerVehicle.model.model : "",
              series: _vm.innerVehicle.model
                ? _vm.innerVehicle.model.series
                : "",
              "is-ntar": _vm.isOrm || _vm.isNtar,
            },
            on: {
              ok: _vm.selectMakeModelModal,
              cancel: function ($event) {
                _vm.isCarModelSearchModalActive = false
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column is-flex is-align-items-center" }, [
      _c("i", { staticClass: "icon mdi mdi-car mdi-24px" }),
      _c("p", { staticClass: "title pl-1" }, [_vm._v("Vehicle")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-pencil mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("M3+")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }